import { api } from "../util/api";
export function getAllOrder(body?: any) {
  return api.get("/api/order", body);
}

export function getOrderGoods(body?: any) {
  return api.get("/api/order-goods", body);
}
export function getOrderGoodsMessage(body?: any) {
  return api.get("/api/order-goods/message", body);
}
export function updateDeliveryTimeByOrderDetail(body?: any) {
  return api.post("/api/order-goods/delivery-time", body);
}
export function deliveryMessageByOrderDetail(body?: any) {
  return api.post("/api/order-goods/delivery-message", body);
}
export function deleteOrderDetail(body?: any) {
  return api.delete("/api/order-goods/delete", body);
}

export function getOrderById(id: string) {
  return api.get(`/api/order/${id}`);
}

export function deleteOrder(id: string) {
  return api.delete(`/api/order`, { id });
}
export function updateOrder(body: any) {
  return api.patch(`/api/order`, body);
}

export function completeOrder(body: any) {
  return api.post(`/api/order/complete`, body);
}

export function needPayOrder(body: any) {
  return api.post(`/api/order/need-pay`, body);
}

export function invoiceOrder(body: any) {
  return api.post(`/api/order/invoice`, body);
}
export function payOrder(body: any) {
  return api.post(`/api/order/pay`, body);
}

export function orderDeliveryNotify(body: any) {
  return api.post(`/api/order/delivery-notify/`, body);
}

export function notiflyTheOrderGoodsArrival(body: any) {
  return api.post(`/api/order/goods-arrival-notify/`, body);
}
